let instantQuoteModal = $('#instant-quote-popup'),
    instantQuoteModalClose = $('#close-instant-quote-popup');

instantQuoteModalClose.on('click', function () {
    hideInstantQuoteModal();
});

instantQuoteModal.on('click', function (e) {
    if ($(e.target).is(instantQuoteModal)) {
        hideInstantQuoteModal();
    }
});

$('.frame-inner').on('click', function (e) {
    e.stopPropagation();
});

function showInstantQuoteModal() {
    instantQuoteModal.addClass('active');
    setTimeout(function () {
        instantQuoteModal.addClass('showing');
    }, 10);
}

function hideInstantQuoteModal() {
    instantQuoteModal.removeClass('showing');
    setTimeout(function () {
        instantQuoteModal.removeClass('active');
    }, 310);
}

// any href #instant-quote
$('a[href="#instant-quote"]').on('click', function (e) {
    e.preventDefault();
    showInstantQuoteModal();
});

// if ?instant-quote is in url, show modal
if (window.location.search.includes('instant-quote')) {
    setTimeout(function () {
        showInstantQuoteModal();
    }, 1500);
}
